import http from "infra/http";
import { useMutation } from "react-query";

function useToggleAreaComumStatus(tenantId: string) {
  return useMutation(
    "/v1/tenants/mudar-status",
    async (params: { id: string; nextStatus: boolean }) =>
      http.put(
        `/v1/tenants/${tenantId}/area-comum/${params.id}/${
          params.nextStatus ? "ativar" : "desativar"
        }`
      )
  );
}

export default useToggleAreaComumStatus;
